import Button from '@mui/material/Button';

const rootCss = ({ typography }) => ({
  borderRadius: 30,
  padding: '16px 28px',
  fontSize: typography.pxToRem(16),
});

export default function ButtonXL(props) {
  const { className, rootComponent: Component = Button, ...rest } = props;
  return <Component className={className} css={rootCss} size="large" {...rest} />;
}
